const typeOf = {
    isObject(value) {
        return value !== null && !Array.isArray(value) && typeof value === 'object';
    },

    isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    },

    isString(value) {
        return typeof value === 'string';
    },

    isArray(value) {
        return Array.isArray(value);
    },

    isBoolean(value) {
        return typeof value === 'boolean';
    },

    isRegExp(value) {
        return value === RegExp(value);
    },

    isFunction(value) {
        return typeof value === 'function';
    }
};

export default typeOf;
